import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Row, Col } from 'antd'

import DrugAliases from '@components/Popup/DrugAliases'
import SearchBar from './SearchBar'
import List from './List'
@inject((store: any) => {
    const { drugsStore, popupStore } = store
    return { drugsStore, popupStore }
})
@observer
class Drugs extends Component<any, any> {
    async componentDidMount() {
        const { drugsStore } = this.props
        await drugsStore.getDrugs()
    }

    render() {
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader onBack={() => window.history.back()} title="תרופות" />
                <Row>
                    <Col>
                        <SearchBar />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <List />
                    </Col>
                </Row>
                <DrugAliases />
            </Layout>
        )
    }
}

export default withRouter(Drugs)
